import React, { useEffect, useState } from "react";
import { Col, Row, Table, Button } from "reactstrap";
import DateFilter from "../../common/views/DateFilter";
import { PosAnalyticsModel } from "../../pos/models/PosAnalyticsModel";
import { useDispatch, useSelector } from "react-redux";
import { userAnalyticsApi, selectAllUserData, setGroupBy, setSorting, setFilters } from "../reducers/userAnalyticsSlice";
import { UserAnalyticsModel } from "../models/UserAnalyticsModel";
import moment from 'moment-timezone';
import { CsvMaker } from "../../../lib/utils/CsvMaker";

const UsersData = () => {
  const [groupBy, setGroupBy] = useState(UserAnalyticsModel.GROUP_MONTHLY)
  const [fromDate, setFromDate] = useState(moment().subtract(12, "months").set({hour:0, minute:0, second:0, millisecond:0}).format('YYYY-MM-DD HH:mm:ss'))
  const [toDate, setToDate] = useState(moment().set({hour:0, minute:0, second:0, millisecond:0}).format('YYYY-MM-DD HH:mm:ss'))

  const userDataList = useSelector((state) => selectAllUserData(state) )
  const [parsedDataList, setParsedDataList] = useState([])
  const [headerDataList, setHeaderDataList] = useState([])
  const [footerDataList, setFooterDataList] = useState([])

  const dispatch = useDispatch()

  const getMonthName = (monthNumber) => {
    const date = new Date();
    date.setMonth(monthNumber);
  
    return date.toLocaleString('it', { month: 'short' }).toUpperCase();
  }
    
  const getUserCanoncial = (user) => {
      let canonical = `${user.first_name} ${user.last_name}`.trim()
      return canonical.length > 0 ? canonical : user.email
  }

  const parseData = () => {
    let parsedList = {}
    let totalList = {}
    let headers = []
    let headerData = {}
    
    if(fromDate && toDate) {
      let from = moment(fromDate)
      let to = moment(toDate)
      // console.log(from.format("YYYY-M/W"))

      switch(groupBy) {
          case UserAnalyticsModel.GROUP_YEARLY: to.endOf('year'); from.startOf('year'); break
          case UserAnalyticsModel.GROUP_MONTHLY: to.endOf('month'); from.startOf('month'); break
          case UserAnalyticsModel.GROUP_WEEKLY: to.endOf('isoweek'); from.startOf('isoweek'); break
      }

      while (from.isBefore(to)) {
        switch(groupBy) {
          case UserAnalyticsModel.GROUP_YEARLY:
            headers.push(from.format("YYYY"))
            headerData[from.format("YYYY")] = {year: from.year()}
            console.log('headerData', from.format("YYYY"), {year: from.year()})
            from.add(1, 'year')
            break;
          case UserAnalyticsModel.GROUP_MONTHLY:
            headers.push(from.format("YYYY-M"))
            headerData[from.format("YYYY-M")] = {year: from.year(), month: getMonthName(from.month())}
            from.add(1, 'month')
            break;
          case UserAnalyticsModel.GROUP_WEEKLY:
            headers.push(from.format("YYYY-M-W"))
            headerData[from.format("YYYY-M-W")] = {year: from.year(), month: getMonthName(from.month()), week: from.isoWeek()}
            from.add(1, 'isoweek')
            break;
        }
      }

      // console.log('headers', headers)

      userDataList.map((datum) => {
        if(!parsedList[datum.user.email]) {
          parsedList[datum.user.email] = {}
          headers.map((header) => {
            parsedList[datum.user.email][header] = {user: getUserCanoncial(datum.user), num_checks: 0}
          })
        }
        // let key = ""+datum.year + (datum.month ? "-"+datum.month : "") + (datum.week ? "-"+datum.week : "")
        let key = groupBy === UserAnalyticsModel.GROUP_YEARLY 
          ? moment(datum.last_checked_at).startOf('year').format("YYYY")
          : groupBy === UserAnalyticsModel.GROUP_MONTHLY
            ? moment(datum.last_checked_at).startOf('month').format("YYYY-M")
            : moment(datum.last_checked_at).startOf('isoweek').format("YYYY-M-W")

        parsedList[datum.user.email][key] = {user: getUserCanoncial(datum.user), num_checks: datum.num_checks}
        totalList[key] = totalList[key] ? totalList[key] + datum.num_checks : datum.num_checks 
      })
      
      setHeaderDataList(headerData)
      setParsedDataList(parsedList)
      setFooterDataList(totalList)
    }
  }

  useEffect(() => {
    if(fromDate && toDate) {
      dispatch(userAnalyticsApi.fetchAll( {groupBy: groupBy, term: null, sorting: {}, filters: {from_date: fromDate, to_date: toDate}} ));
    }
  }, [groupBy, fromDate, toDate])

  useEffect(() => {
    parseData()
    console.groupEnd()
  }, [userDataList])

  // useEffect(() => {
  //   console.group('useEffect - useDataList')
  //   console.log('userDataList', userDataList)
  //   console.log('headerDataList', headerDataList)
  //   console.log('headerDataList-keys', Object.keys(headerDataList))
  //   console.log('parsedDataList', parsedDataList)
  //   console.log('footerDataList', footerDataList)
  //   console.groupEnd()
  // }, [footerDataList])


  const downloadCsv = () => {
    let data = []
    Object.keys(parsedDataList).map((key, index) => {
      let row = {}
      let firstHeaderKey = Object.keys(headerDataList)[0]
      row['user'] = parsedDataList[key][firstHeaderKey].user

      Object.keys(headerDataList).forEach((k) => {
        let ksplit = k.split("-")
        let newKey = ksplit.length < 3 ? k : ksplit[0]+"-"+ksplit[1]+"\\"+ksplit[2]
        row[newKey] = parsedDataList[key][k].num_checks
      })

      data.push(row)
    });

    // console.log(data);
    let csvMaker = new CsvMaker();
    csvMaker.parseJsonData(data).downlad('Checklist-utenti.csv')
  }
  
  return (
    <div className="app-drawer">
        <Row className="border-bottom mb-4 ">
          <Col md="11">
            <h1>Checklist utenti</h1>
          </Col>
          <Col md="1">
            <div className="float-end">
              <Button 
                  id="download_csv_btn" 
                  //href={getDownloadUrl("csv")}
                  // tag="a"
                  color="secondary" 
                  onClick={downloadCsv}
              >
                  <span className="fas fa-download"></span> CSV
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <DateFilter 
              from = {fromDate}
              to = {toDate}
              groupBy={groupBy}

              groupByModes={[
                {value: PosAnalyticsModel.GROUP_WEEKLY, label: "settimanale"},
                {value: PosAnalyticsModel.GROUP_MONTHLY, label: "mensile"},
                {value: PosAnalyticsModel.GROUP_YEARLY, label: "annuale"},
              ]}
              onFilterChange={(fromDate, toDate, groupByMode) => {
                setFromDate(fromDate)
                setToDate(toDate)
                setGroupBy(groupByMode)
              }}
            />
          </Col>
        </Row>
        <div className="bg-white app-drawer-content p-4">
          <div style={{height: 'calc(100vh - 431px)', overflow: 'auto'}}>
            <Table responsive hover className="sticky">
              <thead style={{backgroundColor: "#f9f9f9"}}>
                <tr>
                  <th><b>Assistente di rete {headerDataList.length}</b></th>
                  {Object.values(headerDataList).map((header, index) => (
                    <th key={index} style={{whiteSpace: 'nowrap'}}>
                      <span>{header.year}</span>
                      {header.month ? (<><br/><b>{header.month}</b></>): null}
                      {header.week ? (<><br/><span className="font-12">sett. {header.week}</span></>): null}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                  {Object.keys(parsedDataList).map((key, index) => (
                    <tr key={index}>
                      <th style={{backgroundColor: "#ffffff94"}}> <b>{ 
                        parsedDataList[key][Object.keys(headerDataList)[0]] ? parsedDataList[key][Object.keys(headerDataList)[0]].user : "..."
                      }</b></th>
                      {Object.values(parsedDataList[key]).map((datum, index) => (
                        <td key={index}>{datum.num_checks > 0 ? datum.num_checks : <span className="text-muted">{datum.num_checks}</span>}</td>
                      ))}
                    </tr>
                  ))}
              </tbody>
              <tfoot style={{backgroundColor: "#f9f9f9", borderTop: "2px solid #78828c21"}}>
                <tr>
                  <th style={{backgroundColor: "#f9f9f994"}}><b>Totale</b></th>
                  {Object.keys(headerDataList).map((key, index) => (
                    <th key={index}>
                      {footerDataList[key] ? footerDataList[key] : <span className="text-muted">0</span>}
                    </th>
                  ))}
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
    </div>
  );
};

export default UsersData;
